import { Injectable } from '@angular/core';
import { Country, CountryStateServiceInterface, State } from '@vendasta/country-state';
import { Observable } from 'rxjs';
import { ApiService } from '../api-service/api.service';

@Injectable({ providedIn: 'root' })
export class CountryStateService implements CountryStateServiceInterface {
  constructor(private apiService: ApiService) {}

  getCountriesOptions(): Observable<Country[]> {
    const url = '/_ajax/v1/list-countries/';
    return this.apiService.get(url);
  }

  getStatesOptions(countryCode: string): Observable<State[]> {
    const url = '/_ajax/v1/list-states/';
    return this.apiService.get(url, {
      params: { countryCode: countryCode },
    });
  }
}
